import { useTranslation } from 'react-i18next'
import { trackLanguageSwitch } from '../utils/analytics'

/**
 * Seletor de idioma como ETIQUETA tipográfica "PT · EN" (ADR-003; D16): JetBrains Mono Medium 10, caixa alta,
 * sem ícone e sem emoji de bandeira. O idioma ativo fica na cor de ação; o outro, apagado.
 */
const LANGS = [
  { code: 'pt', label: 'PT', name: 'Português' },
  { code: 'en', label: 'EN', name: 'English' },
] as const

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation()
  const current = i18n.language?.startsWith('en') ? 'en' : 'pt'
  const change = (code: string) => {
    if (code === current) return
    trackLanguageSwitch(current, code)
    i18n.changeLanguage(code)
  }
  return (
    <div className="z-lang" role="group" aria-label={t('common.changeLanguage')} data-anatomy="etiqueta">
      {LANGS.map((l, i) => (
        <span key={l.code} className="z-lang__item">
          {i > 0 && <span className="z-lang__sep" aria-hidden="true">·</span>}
          <button
            type="button"
            className={['z-lang__btn', l.code === current && 'is-active'].filter(Boolean).join(' ')}
            aria-pressed={l.code === current}
            aria-label={`${l.code.toUpperCase()} — ${l.name}`}
            lang={l.code}
            onClick={() => change(l.code)}
          >
            {l.label}
          </button>
        </span>
      ))}
    </div>
  )
}
